import clsx from 'clsx'

import styles from './Bubble.module.scss'

interface Props {
  color: string
  icon?: string
  text: string
  direction?: 'up' | 'down' | 'left-down' | 'right-down'
  className?: string
  fontStyle?: string
  fontClassName?: string
}

const Bubble = ({ color, icon, text, className, direction, fontStyle, fontClassName }: Props) => {
  function bubbleBorder() {
    if (direction === 'up') {
      return '0 26px 26px 26px'
    }
    if (direction === 'down') {
      return '26px 26px 26px 0'
    }
    if (direction === 'left-down') {
      return '26px 26px 0 26px'
    }
    if (direction === 'right-down') {
      return '26px 26px 0px 26px'
    }
    return '26px 26px 26px 0'
  }

  return (
    <div className={clsx(styles.container, className)} style={{ backgroundColor: color, borderRadius: bubbleBorder() }}>
      {icon && (
        <div className={styles.iconWrapper}>
          <img src={icon} alt="" />
        </div>
      )}
      <div className={clsx(styles.bubbleText, fontClassName)}>
        <p style={{ fontStyle: fontStyle }}>{text}</p>
      </div>
    </div>
  )
}

export default Bubble
